export default "__VITE_ASSET__D1lRa$HV__"